import { CellContext } from "@tanstack/react-table";
import { TagView } from "generated/graphql";
import { useMemo } from "react";
import { useAppSelector } from "redux/hooks";
import { selectLensEditorFormFields } from "redux/slices/lensEditor";

export function TagFields({ row: { original } }: CellContext<TagView, unknown>) {
  const fields = useAppSelector(selectLensEditorFormFields);
  const fieldMap = useMemo(() => {
    return fields.reduce((map, f) => {
      map[f.id] = f;
      return map;
    }, {});
  }, [fields]);
  return (
    <span className="w-full justify-between inline-flex items-center gap-1">
      <span>
        {original.fields.length === 0 && <p className="text-gray-100 italic">No fields</p>}
        {original.fields.map((f) => (
          <p key={f}>
            {fieldMap[f]?.outlinePrefix} {fieldMap[f]?.name}
          </p>
        ))}
      </span>
    </span>
  );
}
